// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPlanYearResponseDto
 */
export interface IPlanYearResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IPlanYearResponseDto
     */
    plan_year_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPlanYearResponseDto
     */
    plan_year_name?: string;
}

/**
 * Check if a given object implements the IPlanYearResponseDto interface.
 */
export function instanceOfIPlanYearResponseDto(value: object): value is IPlanYearResponseDto {
    return true;
}

export function IPlanYearResponseDtoFromJSON(json: any): IPlanYearResponseDto {
    return IPlanYearResponseDtoFromJSONTyped(json, false);
}

export function IPlanYearResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPlanYearResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'plan_year_id': json['plan_year_id'] == null ? undefined : json['plan_year_id'],
        'plan_year_name': json['plan_year_name'] == null ? undefined : json['plan_year_name'],
    };
}

export function IPlanYearResponseDtoToJSON(json: any): IPlanYearResponseDto {
    return IPlanYearResponseDtoToJSONTyped(json, false);
}

export function IPlanYearResponseDtoToJSONTyped(value?: IPlanYearResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plan_year_id': value['plan_year_id'],
        'plan_year_name': value['plan_year_name'],
    };
}

